import { DrawerHeader, DrawerHeaderProps } from "@fluentui/react-components";


interface DrawerHeaderCustomProps extends DrawerHeaderProps {
  rcName?: string;
}

const DrawerHeaderCustom = (props: DrawerHeaderCustomProps & DrawerHeaderProps) => {
  return <DrawerHeader {...props} />;
};

export default DrawerHeaderCustom;
